class VapDigitalConsent extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-vap-consent-input]');
    this.error = this.querySelector('[data-vap-consent-error]');
    this.form = this.closest('form');
    this.button = this.form?.querySelector('[ref="addToCartButton"]');

    if (!this.input || !this.form || !this.button) return;

    if (!this.button.hasAttribute('data-vap-available-before-consent')) {
      this.button.setAttribute('data-vap-available-before-consent', String(!this.button.disabled));
    }

    this.handleChange = () => this.syncState();
    this.handleInvalid = (event) => {
      event.preventDefault();
      this.showError();
      this.input.focus();
    };
    this.handleSubmit = (event) => {
      if (this.input.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError();
      this.input.focus();
    };

    this.input.addEventListener('change', this.handleChange);
    this.input.addEventListener('invalid', this.handleInvalid);
    this.form.addEventListener('submit', this.handleSubmit, true);
    this.syncState();
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.handleChange);
    this.input?.removeEventListener('invalid', this.handleInvalid);
    this.form?.removeEventListener('submit', this.handleSubmit, true);
  }

  showError() {
    this.dataset.invalid = 'true';
    if (this.error) this.error.hidden = false;
  }

  syncState() {
    const isChecked = this.input.checked;
    const variantWasAvailable =
      this.button.getAttribute('data-vap-available-before-consent') === 'true';

    this.button.disabled = !variantWasAvailable || !isChecked;
    this.button.setAttribute('aria-disabled', String(this.button.disabled));

    if (isChecked) {
      delete this.dataset.invalid;
      if (this.error) this.error.hidden = true;
    }
  }
}

if (!customElements.get('vap-digital-consent')) {
  customElements.define('vap-digital-consent', VapDigitalConsent);
}
